import { createFileRoute, Navigate } from '@tanstack/react-router';
import { pageTitle, usePageTitle } from '@/utils/pageTitle';
import { ClientTable } from '@/components/Pages/Clients/ClientTable';
import { CreateEditClientModal } from '@/components/Pages/Clients/CreateEditClientModal';
import { Box } from '@mui/joy';
import { useAuth } from '@/contexts/AuthContext';

export const Route = createFileRoute('/_protected/clients/')({
  component: ClientsPage,
  head: () => pageTitle('Clientes'),
});

function ClientsPage() {
  usePageTitle('Clientes');
  const { hasClaim, isLoading } = useAuth();
  const canRead = hasClaim('CLIENTS_READ');
  const canWrite = hasClaim('CLIENTS_WRITE');

  if (!isLoading && !canRead) {
    return <Navigate to='/' />;
  }

  return (
    <Box>
      {canWrite && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 3 }}>
          <CreateEditClientModal />
        </Box>
      )}
      <ClientTable />
    </Box>
  );
}
